module.exports = {
	sectors: [
		'Arts',
		'Community',
		'Business',
		'Entertainment',
		'Media',
		'Politics',
		'Sports',
		'STEM'
	],
	fields: [
		'age',
		'bio',
		'claimToFame',
		'id',
		'influence',
		'job',
		'location',
		'rank',
		'reach',
		'sector',
		'substance',
		'twitterFollowers',
		'twitterHandle'
	]
};



// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/data/template.js